import { Space, Spin } from 'antd';

/** Shown while the items' errors are still being worked out, so missing error counts are not read as none. */
const ErrorsCheckStatus = () => (
    <Space size={8} align="center">
        <Spin size="small" />
        <span style={{ color: 'var(--gray-8)' }}>Checking items for errors…</span>
    </Space>
);

export default ErrorsCheckStatus;
